module.exports = __webpack_public_path__ + "static/twitter_facebook-fc1cdb9268ea58cb5607a45d60fb1819.jpg";